import React, { useEffect, useState, useMemo } from "react";
import './index.css';
import axios from 'axios';
import { Button } from "react-bootstrap";
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import DataTable from 'react-data-table-component';
import ShowTime from "../../../utils/ShowTime/ShowTime";
import MapProduct from "../../../utils/ProductMapper/MapProduct";
import { FaEdit, FaRegClock, FaTerminal, FaEnvelope } from "react-icons/fa";
import countryList from 'react-select-country-list';
import Select from 'react-select'
import CustomLoader from "../../../utils/DataTableLoader/CustomLoader";
import { Tooltip } from 'react-tooltip'
import getTimeRelativeToNow from "../../../utils/ShowTime/GetRelativeTime";
import ActivityLogModal from "../../../Components/ActivityLogModal";
import CommandLogModal from "../../../Components/CommandLogModal";
import StatusChip from "../../../Components/StatusChip/StatusChip";
import CSVExportModal from "../../../Components/CSVExport/CSVExportModal";
import TagSelector from "../../../Components/TagSelector/TagSelector";
import TagList from "../../../Components/TagDisplay/TagList";
import ManageTagsModal from "../../../Components/ManageTagsModal/ManageTagsModal";
import TruncatedText, { TruncatedTextTooltip, DateCell, COLUMN_WIDTHS } from "../../../Components/TruncatedText/TruncatedText";
import DateRangeFilter from "../../../Components/DateRangeFilter/DateRangeFilter";
import fetchTagsByIds from "../../../utils/Tags/fetchTagsByIds";
import { Can, useAuth } from "../../../authentication/AuthContext";
import {
  LISTINGS,
  useCustomizableColumns,
  CustomizeTableModal,
  TableCustomizerMenu,
} from "../../../Components/TableCustomizer";

export default function TrialLicenses() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const [screenloader, setScreenloader] = useState(true);
  const now = new Date();

  const [TableData, setTableData] = useState([]);
  const [TotalRecords, setTotalRecords] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("last_seen");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [pending, setPending] = useState(true);

  //filters
  const initialFilters = {
    last_seen: { operator: '', value: '' },
    status: { operator: '', value: '' },
    'l.created_at': { operator: '', value: '' },
    'l.expires_at': { operator: '', value: '' },
    email: { operator: '', value: '' },
    product_version: { operator: '', value: '' },
    product_id: { operator: '', value: '' },
    organization: { operator: '', value: '' },
    country: { operator: '', value: '' },
    fname: { operator: '', value: '' },
    lname: { operator: '', value: '' },
    'tg.tag_id': { operator: '', value: '' },
    // Drops every trial license carrying any of the selected tags. Handled by a
    // subquery on the backend, so it stacks with the include filter above.
    exclude_tag_id: { operator: '', value: '' },
    // "Has this trial user already bought a licence?" — resolved on the backend
    // as an EXISTS over Users+Licenses joined on email. See utils/trialFilters.js.
    converted_customer: { operator: '', value: '' },
  };
  const [filters, setFilters] = useState(initialFilters);
  const [isInitialized, setIsInitialized] = useState(false);
  const [status, setStatus] = useState("");
  const [lastSeen, setLastSeen] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [product, setProduct] = useState("");
  const [email, setEmail] = useState("");
  const [organization, setOrganization] = useState("");
  const [country, setCountry] = useState([]);
  const [version, setVersion] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [tags, setTags] = useState([]);
  const [excludedTags, setExcludedTags] = useState([]);
  const [convertedCustomer, setConvertedCustomer] = useState("");

  // Selection state
  const [selectable, setSelectable] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showManageTagsModal, setShowManageTagsModal] = useState(false);
  const toggleSelectionMode = () => { setSelectable(!selectable); setSelectedRows([]); };

  // Activity log modal state
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedLicenseId, setSelectedLicenseId] = useState(null);
  const [showCommandModal, setShowCommandModal] = useState(false);
  const [selectedMachineId, setSelectedMachineId] = useState(null);
  const [showCSVModal, setShowCSVModal] = useState(false);
  const normalizedCountryList = () => {
    const list = countryList().getData();
    return list.map((country) =>
      country.label === "Viet Nam" ? { ...country, label: "Vietnam" } : country
    );
  };
  const CountriesList = useMemo(() => normalizedCountryList(), []);

  const handleFiltersChange = (key, value, operator) => {
    const newFilters = {
      ...filters,
      [key]: {
        operator: operator,
        value: value
      }
    };
    setFilters(newFilters);
    updateURLParams(newFilters);
  };

  const updateURLParams = (currentFilters) => {
    const params = new URLSearchParams();

    // Add pagination params
    params.set('page', page);
    params.set('pageSize', pageSize);

    // Add sorting params
    if (sortBy) params.set('sortBy', sortBy);
    if (sortOrder) params.set('sortOrder', sortOrder);

    // Add filter params
    Object.entries(currentFilters).forEach(([key, filter]) => {
      if (filter.value) {
        params.set(`${key}_operator`, filter.operator);
        params.set(`${key}_value`, filter.value);
      }
    });

    navigate(`${window.location.pathname}?${params.toString()}`, { replace: true });
  };

  const handleFiltersReset = () => {
    setFilters(initialFilters);
    setStatus("");
    setLastSeen("");
    setCreatedAt("");
    setExpiresAt("");
    setProduct("");
    setEmail("");
    setOrganization("");
    setCountry([]);
    setVersion("");
    setFirstName("");
    setLastName("");
    setTags([]);
    setExcludedTags([]);
    setConvertedCustomer("");
    updateURLParams(initialFilters);
  }

  const handleEnterKeyPress = (e) => {
    var value = e.target.value;
    if (value !== "") {
      value = `%${value}%`
    }
    if (e.key === 'Enter') {
      handleFiltersChange(e.target.id, value, 'LIKE')
    }
  };

  const handleCopyEmailList = () => {
    const emails = Array.from(new Set(selectedRows.map(license => license.email)));
    const emailList = emails.join(', ');
    try {
      navigator.clipboard.writeText(emailList);
      toast.success(`${emails.length} Unique emails copied from selected to clipboard!`);
    } catch (error) {
      toast.error('Failed to copy email list to clipboard');
    }
  };

  const handleActivityClick = (licenseId) => {
    setSelectedLicenseId(licenseId);
    setShowActivityModal(true);
  };

  // Mirrors utils/trialExpiryMail.js on the backend. Used ONLY to word the
  // confirm dialog — the server re-derives the template from expires_at and
  // ignores anything the client thinks, so a stale row here can misword the
  // prompt but can never send the wrong email.
  const previewExpiryMail = (expiresAt) => {
    const expDate = new Date(expiresAt);
    if (!expiresAt || isNaN(expDate.getTime()) || expDate.getTime() <= Date.now()) {
      return { template: "expired", days: 0 };
    }
    const days = Math.max(Math.ceil((expDate.getTime() - Date.now()) / 86400000), 1);
    return { template: "expiring_soon", days };
  };

  const sendExpiryEmail = async (row) => {
    setScreenloader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/admin/trial_licenses/${row.id}/send_expiry_email`,
        {},
        { headers: { "access-token": localStorage.getItem("accessToken") } }
      );
      if (response.data.status) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message || "Could not send the email.");
      }
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        console.error(error);
        toast.error("Something Went Wrong");
      }
    } finally {
      setScreenloader(false);
    }
  };

  const handleExpiryEmailClick = (row) => {
    if (!row.email) {
      toast.error("This trial has no email address on file.");
      return;
    }
    const { template, days } = previewExpiryMail(row.expires_at);
    const what = template === "expired"
      ? 'the "license has expired" email'
      : `the "expires in ${days} day${days === 1 ? "" : "s"}" reminder`;
    confirmAlert({
      title: "Send renewal email?",
      message: `This sends ${what} to ${row.email}. The customer receives it immediately.`,
      buttons: [
        { label: "Send", onClick: () => sendExpiryEmail(row) },
        { label: "Cancel" },
      ],
    });
  };

  const sendBulkExpiryEmails = async (payload) => {
    setScreenloader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/admin/trial_licenses/send_expiry_emails`,
        payload,
        { headers: { "access-token": localStorage.getItem("accessToken") } }
      );
      if (response.data.status) {
        // The backend reports what it actually managed to send, which can be
        // less than requested if Mailgun rejected some addresses.
        if (response.data.failed) {
          toast.error(response.data.message);
        } else {
          toast.success(response.data.message);
        }
      } else {
        toast.error(response.data.message || "Could not send the emails.");
      }
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        console.error(error);
        toast.error("Something Went Wrong");
      }
    } finally {
      setScreenloader(false);
    }
  };

  // Selection only. The admin filters the listing down, ticks the rows, and
  // sends to those — mailing customers is an explicit act of picking people,
  // never a side effect of whichever filters happen to be applied. (The backend
  // also accepts a filter set, but nothing in the UI sends one.)
  const handleBulkExpiryEmailClick = () => {
    const emails = new Set(selectedRows.filter(r => r.email).map(r => r.email.toLowerCase()));
    if (!emails.size) {
      toast.error("None of the selected trials have an email address.");
      return;
    }
    confirmAlert({
      title: "Send expiry emails?",
      message:
        `This emails ${emails.size} ${emails.size === 1 ? "person" : "people"} ` +
        `from ${selectedRows.length} selected ${selectedRows.length === 1 ? "trial" : "trials"}. ` +
        `Each person gets one email, worded for their own trial's expiry date. This cannot be undone.`,
      buttons: [
        {
          label: `Send ${emails.size}`,
          onClick: () => sendBulkExpiryEmails({
            ids: selectedRows.map(r => r.id),
            confirmed_count: emails.size,
          }),
        },
        { label: "Cancel" },
      ],
    });
  };

  const handleCommandLogClick = (machineId) => {
    if (!machineId) {
      toast.error('No machine assigned for this trial yet.');
      return;
    }
    setSelectedMachineId(machineId);
    setShowCommandModal(true);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // Restore pagination
    const urlPage = params.get('page');
    const urlPageSize = params.get('pageSize');
    if (urlPage) setPage(Number(urlPage));
    if (urlPageSize) setPageSize(Number(urlPageSize));

    // Restore sorting
    const urlSortBy = params.get('sortBy');
    const urlSortOrder = params.get('sortOrder');
    if (urlSortBy) setSortBy(urlSortBy);
    if (urlSortOrder) setSortOrder(urlSortOrder);

    // Restore filters
    const restoredFilters = {};
    Object.keys(initialFilters).forEach(key => {
      const operator = params.get(`${key}_operator`);
      const value = params.get(`${key}_value`);
      if (operator && value) {
        if (['last_seen', 'l.created_at'].includes(key)) {
          var formattedValue = new Date(value).toISOString()
        } else if (key == "l.expires_at") {
          var values = value.split(",")
          var formattedValue = [new Date(values[0]).toISOString(), new Date(values[1]).toISOString()];
        } else {
          var formattedValue = value;
        }

        restoredFilters[key] = { operator, value: formattedValue };
        // Restore individual filter states
        switch (key) {
          case 'status':
            setStatus({ value: value, label: value === '1' ? 'Active' : value === '0' ? 'Expired' : 'All' });
            break;
          case 'last_seen':
          case 'l.created_at':
            const timeLabel = getTimeLabel(value);
            if (key === 'last_seen') setLastSeen({ value: formattedValue, label: timeLabel });
            else if (key === 'l.created_at') setCreatedAt({ value: formattedValue, label: timeLabel });
            else setExpiresAt({ value: formattedValue, label: timeLabel });
            break;
          case 'l.expires_at':
            setExpiresAt({ value: formattedValue, label: "All" });
            break;
          case 'product_id':
            setProduct({ value: value, label: getProductLabel(value) });
            break;
          case 'email':
            setEmail(value.replace(/%/g, ''));
            break;
          case 'organization':
            setOrganization(value.replace(/%/g, ''));
            break;
          case 'fname':
            setFirstName(value.replace(/%/g, ''));
            break;
          case 'lname':
            setLastName(value.replace(/%/g, ''));
            break;
          case 'country':
            const countryOption = CountriesList.find(c => c.label === value);
            if (countryOption) setCountry(countryOption);
            break;
          case 'product_version':
            setVersion(value.replace(/%/g, ''));
            break;
          case 'tg.tag_id':
            // The URL only carries ids — resolve them so the chips come back.
            fetchTagsByIds(value).then(setTags);
            break;
          case 'exclude_tag_id':
            fetchTagsByIds(value).then(setExcludedTags);
            break;
          case 'converted_customer':
            setConvertedCustomer({
              value: value,
              label: value === 'yes' ? 'Purchased a License' : value === 'no' ? 'Never Purchased' : 'All',
            });
            break;
        }

      }
    });

    if (Object.keys(restoredFilters).length > 0) {
      setFilters(restoredFilters);
    }
    setIsInitialized(true);

  }, []);

  const getTimeLabel = (value) => {
    const options = [
      { value: getTimeRelativeToNow(0, "day", "past"), label: "Today" },
      { value: getTimeRelativeToNow(1, "day", "past"), label: "Past 1 Day" },
      { value: getTimeRelativeToNow(2, "day", "past"), label: "Past 2 Days" },
      { value: getTimeRelativeToNow(3, "day", "past"), label: "Past 3 Days" },
      { value: getTimeRelativeToNow(1, "week", "past"), label: "Within a Week" },
      { value: getTimeRelativeToNow(1, "month", "past"), label: "Within a Month" },
      { value: getTimeRelativeToNow(2, "month", "past"), label: "Within 2 Months" },
      { value: getTimeRelativeToNow(3, "month", "past"), label: "Within 3 Months" },
      { value: getTimeRelativeToNow(6, "month", "past"), label: "Within 6 Months" }
    ];
    const option = options.find(opt => new Date(opt.value).toISOString() === new Date(value).toISOString());
    return option ? option.label : "All";
  };
  const getProductLabel = (value) => {
    const productOptions = [
      { value: "SPCAD_ACAD_Beta", label: "AUTOCAD" },
      { value: "SPCAD_CADMATE", label: "CADMATE" },
      { value: "SPCAD_GSTARCAD", label: "GSTARCAD" },
      { value: "SPCAD_BRX", label: "BRICSCAD" }
    ];
    const option = productOptions.find(opt => opt.value === value);
    return option ? option.label : "All";
  };

  // Every column this listing can show. `columns` below is the subset the current
  // user has chosen, in their order — that is what the table renders, while
  // anything that legitimately needs the full set (the CSV exporter) keeps using
  // this one.
  const allColumns = [
    {
      name: "Actions",
      // Hidden entirely rather than left as an empty column: omit drops the
      // header as well as the cells.
      omit: !(can(['admin.trial_licenses.show', 'admin.activity_logs.index', 'admin.command_logs.index', 'admin.trial_licenses.send_expiry_email'])),
      sortable: false,
      cell: row => (<>
        <Can permission="admin.trial_licenses.show">
          <FaEdit
            data-tooltip-id="trial-index-edit"
            data-tooltip-content="Edit Trial License"
            data-tooltip-place="top"
            className="edit-icon"
            onClick={() => {
              navigate(`/Admin/triallicenses/edit/${row.id}`, {
                replace: false,
              });
            }}
          />
        </Can>
        {/* These two open modals backed by the activity-log and command-log
            endpoints, so they follow those permissions rather than the trial one. */}
        <Can permission="admin.activity_logs.index">
          <FaRegClock
            data-tooltip-id="trial-index-activity"
            data-tooltip-content="View Activity"
            data-tooltip-place="top"
            className="edit-icon"
            onClick={() => {
              handleActivityClick(row.id);
            }}
          />
        </Can>
        <Can permission="admin.command_logs.index">
          <FaTerminal
            data-tooltip-id="trial-index-commands"
            data-tooltip-content="View Command Logs"
            data-tooltip-place="top"
            className="edit-icon"
            onClick={() => handleCommandLogClick(row.machine_id)}
          />
        </Can>
        <Can permission="admin.trial_licenses.send_expiry_email">
          <FaEnvelope
            data-tooltip-id="trial-index-expiry-email"
            data-tooltip-content={new Date(row.expires_at) <= now ? "Send expiry email" : "Send renewal reminder"}
            data-tooltip-place="top"
            className="edit-icon"
            onClick={() => handleExpiryEmailClick(row)}
          />
        </Can>
      </>
      )
    },
    {
      name: 'Status',
      selector: row => (row.status),
      sortField: "status",
      minWidth: '150px',
      sortable: true,
      cell: row => (<StatusChip expiresAt={row.expires_at} statusFlag={row.status} expiringSoondays={3} pill={true} />),
      exportCell: (row) => { const statusFlag = row.status; const expiresAt = row.expires_at; if (!expiresAt) return 'Active'; const expDate = new Date(expiresAt); const nowLocal = new Date(); const msDiff = expDate.getTime() - nowLocal.getTime(); const daysDiff = msDiff / (1000 * 60 * 60 * 24); if (daysDiff < 0) { return statusFlag === 'active' ? 'Expired (Pending)' : 'Expired'; } if (daysDiff <= 3) return 'Expiring Soon'; return 'Active'; },
    },
    {
      name: 'Email',
      minWidth: `${COLUMN_WIDTHS.email}px`,
      selector: row => row.email,
      sortField: "email",
      sortable: true,
      cell: row => <TruncatedText text={row.email} maxWidth={COLUMN_WIDTHS.email} />,
      exportCell: (row) => row.email,
    },
    {
      name: 'Last Seen',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.last_seen,
      sortField: "last_seen",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.last_seen)} />,
      exportCell: (row) => ShowTime(row.last_seen),
    },
    {
      name: 'Start Date',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.created_at,
      sortField: "created_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.created_at)} />,
      exportCell: (row) => ShowTime(row.created_at),
    },
    {
      name: 'End Date',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.expires_at,
      sortField: "expires_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.expires_at)} />,
      exportCell: (row) => ShowTime(row.expires_at),
    },
    {
      name: 'Tags',
      selector: row => row.tags,
      sortable: false,
      cell: row => <TagList tags={row.tags} />,
    },
    {
      name: 'Product',
      selector: row => row.product_id,
      sortField: "product_id",
      sortable: true,
      minWidth: `${COLUMN_WIDTHS.product}px`,
      cell: row => (
        <TruncatedText text={MapProduct(row.product_id, "simple")} maxWidth={COLUMN_WIDTHS.product}>
          {MapProduct(row.product_id)}
        </TruncatedText>
      ),
      exportCell: (row) => row.product_id,
    },
    {
      name: 'Version',
      selector: row => row.product_version,
      sortField: "product_version",
      sortable: true,
      cell: row => <div>{row.product_version ? row.product_version : '-'}</div>,
      exportCell: (row) => (row.product_version ? row.product_version : '-'),
    },
    {
      name: 'First Name',
      minWidth: `${COLUMN_WIDTHS.name}px`,
      selector: row => row.fname,
      sortField: "fname",
      sortable: true,
      cell: row => <TruncatedText text={row.fname} maxWidth={COLUMN_WIDTHS.name} />,
      exportCell: (row) => (row.fname || ''),
    },
    {
      name: 'Last Name',
      minWidth: `${COLUMN_WIDTHS.name}px`,
      selector: row => row.lname,
      sortField: "lname",
      sortable: true,
      cell: row => <TruncatedText text={row.lname} maxWidth={COLUMN_WIDTHS.name} />,
      exportCell: (row) => (row.lname || ''),
    },
    {
      name: 'Phone',
      minWidth: `${COLUMN_WIDTHS.phone}px`,
      selector: row => row.phone,
      sortField: "phone",
      sortable: true,
      cell: row => <TruncatedText text={row.phone} maxWidth={COLUMN_WIDTHS.phone} />,
      exportCell: (row) => (row.phone ? row.phone : '-'),
    },
    {
      name: 'Country',
      minWidth: `${COLUMN_WIDTHS.country}px`,
      selector: row => row.country,
      sortField: "country",
      sortable: true,
      cell: row => <TruncatedText text={row.country} maxWidth={COLUMN_WIDTHS.country} />,
      exportCell: (row) => row.country,
    },
    {
      name: 'Organization',
      minWidth: `${COLUMN_WIDTHS.organization}px`,
      selector: row => row.organization,
      sortField: "organization",
      sortable: true,
      cell: row => <TruncatedText text={row.organization} maxWidth={COLUMN_WIDTHS.organization} />,
      exportCell: (row) => row.organization,
    },
    {
      name: 'Machine ID',
      minWidth: `${COLUMN_WIDTHS.machine}px`,
      selector: row => row.machine_id,
      cell: row => <TruncatedText text={row.machine_id} maxWidth={COLUMN_WIDTHS.machine} mono />,
    },

  ];

  // "Actions" is locked: it is the only route to the edit screen and the log
  // modals, so it stays visible and leftmost rather than being something a user
  // can hide and then have to go hunting in the menu to get back.
  const {
    columns,
    ready: columnsReady,
    menuProps: tableMenuProps,
    customizerProps: tableCustomizerProps,
  } = useCustomizableColumns({
    listingKey: LISTINGS.ADMIN_TRIAL_LICENSES,
    columns: allColumns,
    lockedColumnIds: ["Actions"],
  });

  // The active filters as [{column, operator, value}]. The GET listing flattens
  // this into filters[i][key] query params; the bulk-email POST sends it as JSON
  // untouched. Both must describe the same set — the whole safety story for a
  // bulk send is that the recipients are exactly what the admin saw listed.
  const buildFilterArray = () => Object.keys(filters)
    .filter(key => filters[key].value)
    .map(key => ({
      column: key,
      operator: filters[key].operator,
      value: filters[key].value,
    }));

  const getList = async () => {
    try {
      const formattedFilters = buildFilterArray()
        .map((f, index) => ({
          [`filters[${index}][column]`]: f.column,
          [`filters[${index}][operator]`]: f.operator,
          [`filters[${index}][value]`]: f.value,
        }))
        .reduce((acc, obj) => ({ ...acc, ...obj }), {});

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/trial_licenses/`, {
        params: {
          limit: pageSize,
          page: page,
          sort_by: sortBy,
          sort_order: sortOrder,
          ...formattedFilters
        },
        headers: {
          'access-token': localStorage.getItem('accessToken'),
        },
      });
      setScreenloader(false);
      setPending(false);
      if (response.data.status) {
        const total = response.data.meta.pagination.total;
        setTotalRecords(total);
        setTableData(response.data.licenses);
      } else {
        toast.error('Something Went Wrong');
        console.log(response.data);
      }
    } catch (error) {
      setScreenloader(false);
      setPending(false);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        console.error(error);
        toast.error('Something Went Wrong');
      }
    }
  };

  useEffect(() => {
    if (!isInitialized) return;
    setPending(true);
    getList();
  }, [filters, page, pageSize, sortBy, sortOrder, isInitialized]);


  const conditionalRowStyles = [
    {
      //Active licenses
      when: row => (new Date(row.expires_at) > now),
      style: {
        backgroundColor: '#8ebca1ff',
        color: 'black',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    {
      //Expired licenses
      when: row => (new Date(row.expires_at) < now && row.status == false),
      style: {
        backgroundColor: '#f3f2f2ff',
        color: 'black',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    {
      //Expired but user hasn't logged for the status to be updated
      when: row => (new Date(row.expires_at) < now && row.status == true),
      style: {
        backgroundColor: '#f3f2f2ff',
        color: 'black',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    {
      //Expiring soon
      when: row => (isExpiringSoon(row.expires_at)),
      style: {
        backgroundColor: '#8478afcb',
        color: 'black',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ]

  const isExpiringSoon = (expiresAt) => {
    const expDate = new Date(expiresAt);
    if (expDate <= now) return false;
    const msInDay = 24 * 60 * 60 * 1000;
    const threshold = now.getTime() + 3 * msInDay;
    return expDate.getTime() > now.getTime() && expDate.getTime() <= threshold;
  };

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>

            <div className="row mb-3">
              <div className="col-md-6">
                <h2>Trial Licenses</h2>
              </div>
            </div>

            <div className="filters row">

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="fname"
                    value={firstName}
                    placeholder="First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                    onKeyDown={handleEnterKeyPress}
                  />
                  {firstName && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'fname', value: firstName } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="fname"
                    value={lastName}
                    placeholder="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                    onKeyDown={handleEnterKeyPress}
                  />
                  {lastName && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'lname', value: lastName } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={handleEnterKeyPress}
                  />
                  {email && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'email', value: email } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <Select
                  classNamePrefix="rs"
                  placeholder="Country"
                  options={CountriesList}
                  value={country}
                  onChange={(e) => { setCountry(e); handleFiltersChange('country', e.label, '=') }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="organization"
                    value={organization}
                    placeholder="Organization"
                    onChange={(e) => setOrganization(e.target.value)}
                    onKeyDown={handleEnterKeyPress}
                  />
                  {organization && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'organization', value: organization } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <Select
                  classNamePrefix="rs"
                  placeholder="Product"
                  options={[
                    { value: "", label: "All" },
                    { value: "SPCAD_ACAD_Beta", label: "AUTOCAD" },
                    { value: "SPCAD_CADMATE", label: "CADMATE" },
                    { value: "SPCAD_GSTARCAD", label: "GSTARCAD" },
                    { value: "SPCAD_BRX", label: "BRICSCAD" },
                    { value: "SPCAD_ZWCAD", label: "ZWCAD" },
                    { value: "SPCAD_PCAD", label: "PCAD" },

                  ]}
                  value={product}
                  onChange={(e) => { setProduct(e); handleFiltersChange('product_id', e.value, '=') }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="product_version"
                    value={version}
                    placeholder="Product Version"
                    onChange={(e) => setVersion(e.target.value)}
                    onKeyDown={handleEnterKeyPress}
                  />
                  {version && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'product_version', value: version } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <Select
                  classNamePrefix="rs"
                  placeholder="Status"
                  options={[
                    { value: "", label: "All" },
                    { value: "1", label: "Active" },
                    { value: "0", label: "Expired" },
                  ]}
                  value={status}
                  onChange={(e) => { setStatus(e); handleFiltersChange('status', e.value, '=') }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <DateRangeFilter
                  placeholderText="Last Seen"
                  startDate={lastSeen[0]}
                  endDate={lastSeen[1]}
                  onChange={(dates) => {
                    setLastSeen(dates);
                    const [start, end] = dates;
                    if (start && end) {
                      handleFiltersChange('last_seen', [start.toISOString(), end.toISOString()], 'BETWEEN');
                    } else if (!start && !end) {
                      handleFiltersChange('last_seen', '', '');
                    }
                  }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <DateRangeFilter
                  placeholderText="Start Date"
                  startDate={createdAt[0]}
                  endDate={createdAt[1]}
                  onChange={(dates) => {
                    setCreatedAt(dates);
                    const [start, end] = dates;
                    if (start && end) {
                      handleFiltersChange('l.created_at', [start.toISOString(), end.toISOString()], 'BETWEEN');
                    } else if (!start && !end) {
                      handleFiltersChange('l.created_at', '', '');
                    }
                  }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <DateRangeFilter
                  placeholderText="End Date"
                  startDate={expiresAt[0]}
                  endDate={expiresAt[1]}
                  onChange={(dates) => {
                    setExpiresAt(dates);
                    const [start, end] = dates;
                    if (start && end) {
                      handleFiltersChange('l.expires_at', [start.toISOString(), end.toISOString()], 'BETWEEN');
                    } else if (!start && !end) {
                      handleFiltersChange('l.expires_at', '', '');
                    }
                  }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <TagSelector
                  placeholder="Tags"
                  value={tags}
                  onChange={(selected) => {
                    setTags(selected);
                    // For multi-select, we need to handle values array
                    // Backend expects filters[...][value] = 'id1,id2' and operator 'IN'
                    const values = selected ? selected.map(s => s.value).join(',') : '';
                    handleFiltersChange('tg.tag_id', values, 'IN');
                  }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <TagSelector
                  placeholder="Exclude Tags"
                  value={excludedTags}
                  onChange={(selected) => {
                    setExcludedTags(selected);
                    const values = selected ? selected.map(s => s.value).join(',') : '';
                    handleFiltersChange('exclude_tag_id', values, 'NOT IN');
                  }}
                />
              </div>

              {/* Trials belonging to people who already bought. They are the one
                  audience the expiry mailers must never reach — those emails ask
                  the reader to go and purchase a license. */}
              <div className="col-md-3 mb-3">
                <Select
                  classNamePrefix="rs"
                  placeholder="Purchased License"
                  options={[
                    { value: "", label: "All" },
                    { value: "no", label: "Never Purchased" },
                    { value: "yes", label: "Purchased a License" },
                  ]}
                  value={convertedCustomer}
                  onChange={(e) => { setConvertedCustomer(e); handleFiltersChange('converted_customer', e.value, '='); }}
                />
              </div>
            </div>

            <div className="row g-2 align-items-end">
              {/* Left Section */}
              <div className="col-12 col-md-10 d-flex flex-wrap gap-2 align-items-center">
                {selectable ? (
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <Button onClick={toggleSelectionMode} variant="secondary">
                      Cancel Selection
                    </Button>

                    {selectedRows.length > 0 && (
                      <>
                        <Button className="admin-btn" onClick={() => setShowManageTagsModal(true)}>
                          Manage Tags
                        </Button>
                        <Button className="admin-btn" onClick={() => setShowCSVModal(true)}>
                          Export CSV
                        </Button>
                        <Button className="admin-btn" onClick={handleCopyEmailList}>
                          Copy Emails
                        </Button>
                        <Can permission="admin.trial_licenses.send_bulk_expiry_email">
                          <Button variant="warning" onClick={handleBulkExpiryEmailClick}>
                            Send Expiry Emails
                          </Button>
                        </Can>
                      </>
                    )}

                    {selectedRows.length > 0 && (
                      <span className="ms-2 text-muted">
                        {selectedRows.length} Selected
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="d-flex flex-wrap gap-2">
                    <Button className="admin-btn" onClick={toggleSelectionMode}>
                      Enable Selection
                    </Button>
                    <Button className="admin-btn" onClick={() => setShowCSVModal(true)}>
                      Export CSV
                    </Button>
                  </div>
                )}
              </div>

              {/* Right Section */}
              <div className="col-12 col-md-2 d-flex justify-content-md-end align-items-center gap-2">
                {JSON.stringify(filters) !== JSON.stringify(initialFilters) && (
                  <Button
                    onClick={handleFiltersReset}
                    variant="primary"
                    // Was w-100 on mobile; now it shares the row with the
                    // three-dot menu, so it grows to fill what's left instead of
                    // claiming the full width and pushing the menu out.
                    className="admin-btn flex-grow-1 flex-md-grow-0"
                  >
                    Clear all Filters
                  </Button>
                )}
                <TableCustomizerMenu {...tableMenuProps} />
              </div>
            </div>

            <CustomizeTableModal {...tableCustomizerProps} title="Customize Trial Licenses Table" />

            <ManageTagsModal
              show={showManageTagsModal}
              onHide={() => setShowManageTagsModal(false)}
              selectedIds={selectedRows.map(row => row.id)}
              type="TrialLicense"
              onSuccess={() => {
                getList();
                setSelectedRows([]);
                setSelectable(false);
              }}
            />

            <div className="row d-flex d-sm-none">
              <p>Total Records: <strong>{TotalRecords}</strong></p>
            </div>

            <CSVExportModal
              show={showCSVModal}
              onHide={() => setShowCSVModal(false)}
              columns={allColumns}
              rows={selectedRows.length > 0 ? selectedRows : TableData}
              filename={selectedRows.length > 0 ? `trials_selected_${selectedRows.length}_rows.csv` : `trials_visible_page_${page}_per_${pageSize}.csv`}
              excludeColumnNames={["Actions"]}
              preselectedColumnNames={["Email", "Start Date", "End Date", "Product"]}
            />

            {/* Held until the saved column layout is known — rendering the
                defaults first and then re-laying-out is a visible jump. */}
            <div className="table-wrapper">
              {!columnsReady ? <CustomLoader /> : (
              <DataTable
                //data
                columns={columns}
                data={TableData}
                //style
                dense
                direction="auto"
                highlightOnHover
                noHeader
                persistTableHead
                pointerOnHover
                responsive
                subHeaderAlign="right"
                subHeaderWrap
                progressPending={pending}
                progressComponent={<CustomLoader />}
                conditionalRowStyles={conditionalRowStyles}
                //selection
                selectableRows={selectable}
                onSelectedRowsChange={({ selectedRows }) => setSelectedRows(selectedRows)}
                clearSelectedRows={!selectable}
                //pagination
                pagination
                paginationServer
                paginationPerPage={pageSize}
                paginationTotalRows={TotalRecords}
                paginationRowsPerPageOptions={[10, 20, 50, 100, 150, 500, 1000, 1500]}
                onChangePage={(page) => setPage(page)}
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => { setPageSize(currentRowsPerPage); setPage(currentPage) }}
                sortServer
                onSort={(column, sortDirection) => { setSortBy(column.sortField); setSortOrder(sortDirection); }}
              />
              )}
            </div>
          </div>
        </div>
        <Tooltip id="trial-index-edit" style={{ zIndex: 99 }} />
        <Tooltip id="trial-index-activity" style={{ zIndex: 99 }} />
        <Tooltip id="trial-index-commands" style={{ zIndex: 99 }} />
        <Tooltip id="trial-index-expiry-email" style={{ zIndex: 99 }} />
        <TruncatedTextTooltip />

        <ActivityLogModal
          show={showActivityModal}
          onHide={() => setShowActivityModal(false)}
          sourceType="TrialLicenses"
          sourceId={selectedLicenseId}
          title="Trial License Activity Logs"
        />
        <CommandLogModal
          show={showCommandModal}
          onHide={() => setShowCommandModal(false)}
          machineId={selectedMachineId}
          title="Trial Machine Command Logs"
        />
      </div>
    </div >
  );
}